import CalendarCommunicationSettings from '@/entities/CalendarCommunicationSettings'
import { CALENDAR_TYPES } from '@/views/constants'
/*
 providers that are borrowed from other calendar
 this data collects  only if calendar "availability_as" settings set to "other calendar"
 used to display availability with as "other provider"
 */
export default class CalendarBorrowedProviders {
  constructor (calendarType = CALENDAR_TYPES.PRACTICE_TYPE, communicationSettings = new CalendarCommunicationSettings(), calendarIndexToLocationAndProviderMap = {}, calendarIdToIndexMap = {}) {
    this.list = []
    this.current = null
    if (
      [CALENDAR_TYPES.PROVIDER_LOCATION_TYPE, CALENDAR_TYPES.PROVIDER_TYPE].includes(calendarType) &&
      communicationSettings.availabilityCalendarId
    ) {
      const otherCalendarIndex = calendarIdToIndexMap[communicationSettings.availabilityCalendarId]
      if (otherCalendarIndex) {
        this.list = calendarIndexToLocationAndProviderMap[otherCalendarIndex]?.original?.allProviders?.list || []
        this.current = calendarIndexToLocationAndProviderMap[otherCalendarIndex]?.original?.allProviders?.current || null
      }
    }
  }
}
